var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgUploadFiles1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.367,
    height: 50.718,
    viewBox: "0 0 49.367 50.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file_upload_FILL0_wght700_GRAD200_opsz48",
    d: "M27.311,40.578V16.536l-7.631,7.7-4.39-4.457L30.417,4.65l15.2,15.128-4.525,4.457-7.631-7.7V40.578ZM11.846,55.368a5.942,5.942,0,0,1-4.288-1.823A5.93,5.93,0,0,1,5.7,49.155v-12.7h6.146v12.7H48.922v-12.7h6.146v12.7a5.879,5.879,0,0,1-1.891,4.39,5.981,5.981,0,0,1-4.255,1.823Z",
    transform: "translate(-5.7 -4.65)",
    fill: "#43496a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgUploadFiles1);
export default __webpack_public_path__ + "static/media/bg-upload-files-1.78f027ac5eabafe53b7b8fc9ab288aba.svg";
export { ForwardRef as ReactComponent };